import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Client } from "./SystemApiClient";
import { GlobalConstants } from "src/app/common/globals";

@Injectable({ providedIn: 'root' })
export class SystemApiClient extends Client {
    [x: string]: any;
  
    constructor(private httpClient : HttpClient) {
        super(httpClient, GlobalConstants.apiBaseUrl);
    }
}